
export const APP_URL = (import.meta.env.VITE_SITE_URL as string);
export const API_URL = (import.meta.env.VITE_API_URL as string);

if (!API_URL) {
    console.error('VITE_API_URL is not defined in environment variables');
}

export const APP_CONFIG = {
    siteName: 'MegaJobNepal',
    siteUrl: APP_URL || 'https://megajobnepal.com',
    tagline: "Nepal's Premier Job Portal",
    description: 'Connect talented professionals with leading employers across Nepal.',

    company: {
        name: 'MegaJobNepal Pvt. Ltd.',
        address: 'Putalisadak, Kathmandu, Nepal',
        location: 'Putalisadak, Kathmandu, Nepal',
        phone: '+977-9851403774',
        coordinates: {
            latitude: '27.7172',
            longitude: '85.3240'
        }
    },

    emails: {
        contact: 'info@megajobnepal.com',
        support: 'support@megajobnepal.com',
        business: 'info@megajobnepal.com',
        media: 'media@megajobnepal.com',
        careers: 'hr@megajobnepal.com',
        admin: 'admin@megajobnepal.com'
    },

    phones: {
        support: '+977-1-4444568',
        media: '+977-1-4444569',
        hr: '+977-1-4444570'
    },

    socials: {
        facebook: 'https://facebook.com/megajobnepal',
        twitter: 'https://twitter.com/megajobnepal',
        linkedin: 'https://linkedin.com/company/megajobnepal',
        instagram: 'https://instagram.com/megajobnepal',
        youtube: 'https://youtube.com/megajobnepal'
    },

    maps: {
        embedUrl: 'https://maps.google.com/maps?q=Putalisadak+Kathmandu+Nepal&output=embed',
        link: 'https://goo.gl/maps/putalisadak-kathmandu'
    }
};
